
<style type="text/css">
  .pdf__tabletotal-company img {
  align-self: center;
}
</style>
@if (!pdfDoc) {
  <link  [href]="printPdfCssHref" media="print" rel="stylesheet"/>
}
@if (pdfDoc) {
  <link [href]="printPdfCssHref" media="all" rel="stylesheet" (load)="onPrintCssLoaded()" (error)="onPrintCssLoaded()"/>
}
@if (pdfDoc) {
  <nav class="navbar navbar--central navbar--screen-view fixed-top" style="top: 0px;">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-policy">
        <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
          <a>Quote Schedule</a>
        </div>
        <a href="javascript:;" (click)="questionService?.goBack()"  class="navbar-policy__close icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
        <div class="navbar-policy__nav d-lg-none">
          <div class="navbar-policy__nav-current"><strong>Quote Schedule</strong></div>
        </div>
      </div>
    </div>
  </nav>
}
@if (!pdfDoc) {
  <nav class="navbar navbar--central fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-sub">
        <a href="javascript:;" (click)="questionService?.goBack()" class="navbar-sub__back">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </a>
        <div class="navbar-sub__nav text-left">
          Quote schedule
        </div>
        <div class="navbar-sub__more">
          <div class="navbar-sub__search">
            <div class="navbar-sub__search-trigger icon-hover icon-hover--alt" id="search-trigger">
              <svg class="icon">
                <use xlink:href="#search"></use>
              </svg>
            </div>
            <div class="navbar-sub__search-container" id="search-container">
              <div class="form-control__wrap has-clear">
                <input type="search" placeholder="Search" id="search-input" autocomplete="off" class="form-control form-control--sm">
                <a href="#" id="search-clear" class="form-control__clear"><svg class="icon">
                  <use xlink:href="#close-circle-small"></use>
                </svg></a>
              </div>
              <div class="navbar-sub__search-up" title="Prev">
                <svg class="icon">
                  <use xlink:href="#dropdown-up-medium"></use>
                </svg>
              </div>
              <div class="navbar-sub__search-down" title="Next">
                <svg class="icon">
                  <use xlink:href="#dropdown-down-medium"></use>
                </svg>
              </div>
            </div>
            <a href="#" class="navbar-sub__search-close icon-hover icon-hover--alt" id="search-close">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </a>
          </div>
          <div class="navbar-sub__share">
            <a href="#modal-share-menu" data-toggle="modal" class="icon-hover icon-hover--alt d-lg-none">
              <svg class="icon">
                <use xlink:href="#share"></use>
              </svg>
            </a>
            <div class="dropdown d-none d-lg-block">
              <a href="#" class="icon-hover icon-hover--alt dropdown-toggle dropdown-toggle--nocaret" data-toggle="dropdown" id="shareDropdown" aria-expanded="false">
                <svg class="icon">
                  <use xlink:href="#share"></use>
                </svg>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <div class="profile-drop">
                  <div class="profile-drop__inner">
                    <ul class="profile-drop__list list-unstyled">
                      <li>
                        <a href="javascript:;" (click)="preparePDF()">
                          <svg class="icon">
                            <use xlink:href="#download"></use>
                          </svg>
                          <span>Download</span>
                        </a>
                      </li>
                      <!-- <li>
                      <a href="#share-email-modal" data-toggle="modal" target="_blank">
                        <svg class="icon">
                          <use xlink:href="#envelope"></use>
                        </svg>
                        <span>Email</span>
                      </a>
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="navbar-sub__support">
          <div class="navbar-actions__chat dropdown dropdown--persist" id="chatDropdown">
            <a href="#" role="button" id="chatTrigger" data-toggle="dropdown" title="Chat" aria-haspopup="true" aria-expanded="false">
              <span class="d-none d-lg-inline">Help</span>
              <svg class="icon d-lg-none">
                <use xlink:href="#chat"></use>
              </svg>
              <svg class="icon d-none d-lg-inline-block">
                <use xlink:href="#chat"></use>
              </svg>
            </a>
            <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
              <div class="chat-info has-emergency">
                <div class="container">
                  <div class="chat-info__avatar">
                    <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <div class="chat-info__content">
                    <h5>Hi 👋! How can we help?</h5>
                    <p>Start chatting with the next available agent, or if you prefer a friendly voice our
                    licensed Everything.Insure brokers are ready to assist.</p>
                    <a href="#" class="button button--primary">Start Chat</a>
                  </div>
                  <div class="chat-info__close dropdown-close">
                    <svg class="icon">
                      <use xlink:href="#close-circle-small"></use>
                    </svg>
                  </div>
                </div>
                <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                  <div class="container">
                    <div class="accordion__item">
                      <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                        <div class="accordion__title-text">
                          <h6>We can create a quote for you</h6>
                        </div>
                        <div class="accordion__title-caret">
                          <svg class="icon">
                            <use xlink:href="#chevron-down-smaller"></use>
                          </svg>
                        </div>
                      </a>
                      <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                        <div class="accordion__content">
                          <span class="tag tag--sm tag--free mb-10">Free Service</span>
                          <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that
                            to
                          build a new quote for you!</p>
                          <p>
                            <a href="#create-quote-modal" data-toggle="modal" class="button-control button-control--tight">
                              <svg class="icon icon--sm">
                                <use xlink:href="#upload"></use>
                                </svg><strong>Upload Schedule</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>Chat to a broker</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-down-smaller"></use>
                            </svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <p>Our licensed Everything.Insure brokers are ready to help you. Please get in
                            touch.</p>
                            <p class="chat-info__accordion-call">
                              <svg class="icon icon--sm">
                                <use xlink:href="#phone-filled"></use>
                              </svg>
                              <strong class="font-16">011 510 1300</strong>
                              <span>or</span>
                              <a href="#request-call-modal" data-toggle="modal"><strong>Request a
                              Call</strong></a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#" class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <h6>Let us help you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-info__emergency">
                  <a href="https://www.everything.insure/pages/everything.login.html" target="_blank">
                    <svg class="icon">
                      <use xlink:href="#navigation-sos"></use>
                    </svg>
                    Emergency services
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-sub__close d-none d-lg-block">
            <a href="javascript:;" (click)="questionService?.goBack()" data-toggle="modal" class="icon-hover icon-hover--alt">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
}
@if (!pdfDoc) {
  <div class="breadcrumbs">
    <!-- <ul class="breadcrumbs__list">
    <li><a href="javascript:;" [routerLink]="(user?.broker_id > 0 || user?.console_access) ? '/everything.policy-holders': '/everything.policies-landing'">Policies</a></li>
    <li><a href="javascript:;" routerLink="/everything.policy-overview">{{policyDetails[1]?.schedule[0]?.product}}</a></li>
    <li><a href="javascript:;" routerLink="/everything.policy-resources">Documents</a></li>
    <li>Policy schedule</li>
  </ul> -->
</div>
}

<!-- <div class="loader loader--fs" [ngClass]="{'show': spinner}">
<div class="loader__inner">
  <ng-lottie [options]="options"></ng-lottie>
  <div class="loader__text">
    One moment, please…
  </div>
</div>
</div> -->
<main class="page-main" id="main">
  <div [ngClass]="pdfDoc ? null:'layout layout--central'">
    <div [ngClass]="pdfDoc ? null:'layout__row'">
      @if (!pdfDoc) {
        <div class="layout__sidecol">
          <nav class="central-nav has-scrollto has-burger">
            <ul class="central-nav__list list-unstyled" id="docs-nav">
              <li class="is-spied">
                <a href="#anchor-overview"><span>Overview</span></a>
              </li>
              <li>
                <a href="#anchor-details"><span>Details</span></a>
              </li>
              <li>
                <a href="#anchor-quote-summary"><span>Quote Summary</span></a>
              </li>
              <li>
                <a href="#anchor-benefits-summary"><span>Benefits Summary</span></a>
              </li>
              @for (setNineHeaders of classHeaders; let i = $index; track setNineHeaders) {
                <li>
                  <a [href]="'#'+constructID(setNineHeaders?.class_name)"><span>{{setNineHeaders?.class_name}}</span></a>
                </li>
              }
              <li>
                <a href="#anchor-conditions"><span>Conditions</span></a>
              </li>
              <li>
                <a href="#anchor-benefits-conditions"><span>Benefits Conditions</span></a>
              </li>
              <li>
                <a href="#anchor-disclosure-notice"><span>Disclosure Notice</span></a>
              </li>
            </ul>
            <div class="central-nav__burger">
              <svg class="icon">
                <use xlink:href="#menu"></use>
              </svg>
            </div>
          </nav>
        </div>
      }
      <div [ngClass]="pdfDoc ? null:'layout__bodycol'" id="search-body">
        <section [ngClass]="pdfDoc ? 'pdf-page pdf-page--cover': 'pdf-view'" id="anchor-overview" data-title="Overview">
          <div class="pdf-page__component">
            <header class="pdf__coverhead">
              <div class="pdf__coverhead-logo">
                <span><img [src]="quoteDetails?.broker_logo_1" alt="Everything.Insure"></span>
                <span class="pdf__coverhead-tagline"><img [src]="quoteDetails?.broker_logo_2" alt="Your only insurance platform"></span>
              </div>
              <div class="pdf__coverhead-company">
                <img src="{{quoteDetails?.product_logo}}" class="img-fluid">
              </div>
            </header>
            <div class="pdf__cover-details">
              <h1>Quote Schedule</h1>
              <ul class="list-unstyled">
                <!-- <ng-container *ngFor="let item of policyDetails[1]?.schedule[0] | keyvalue">
                <li>{{(item?.key.toString()) | titlecase}}: <span class="font-semibold">{{(item?.value.toString())}}</span></li>
              </ng-container> -->
              <li>Date: <span class="font-semibold">{{quoteDetails?.['quote date']}}</span></li>
              <li>Quote No: <span class="font-semibold">{{quoteDetails?.['quote no']}}</span></li>
              <!-- <li>Tial Ref No: <span class="font-semibold">{{quoteDetails[1]?.schedule[0]?.['tial ref no']}}</span></li> -->
              <li>Quote Holder: <span class="font-semibold">{{policyHolderDetails?.policyholder}}</span></li>
              <li>Product: <span class="font-semibold">{{quoteDetails?.product}}</span></li>
            </ul>
          </div>

          <!-- 'did you know' cover element -->
          @if (pdfDoc) {
            <div  class="pdf__cover-dyk">
              <img src="https://assets.everything.insure/img/home/header-everything.svg" class="pdf__cover-dyk-bg">
              <img src="https://assets.everything.insure/img/policy-schedule-cover-img.png" class="pdf__cover-dyk-img">
              <div class="pdf__cover-dyk-content">
                <h2 class="font-serif">Did you know?</h2>
                <p>Claiming is quick and easy. You can submit a claim online anytime, anywhere. Stay up-to-date with
                the status of your claims in real-time.</p>
                <p>Simply log in to your app, tap the <strong>Start Claim</strong> button and begin the process.</p>
              </div>
            </div>
          }
          <!-- -->

          <!-- OR 'did you know' image. dimensions: 1980x1940 (990x970) --
          <div class="pdf__cover-dykimage">
            <img src="//placehold.co/1980x1940" class="img-responsive">
          </div>
          -->
        </div>
      </section>

      @if (pdfDoc) {
        <section  class="pdf-page">
          <div class="pdf-page__component">
            <header class="pdf__coverhead">
              <div class="pdf__coverhead-logo">
                <span><img src="https://assets.everything.insure/0/logo.svg" alt="Everything.Insure"></span>
              </div>
              <div class="pdf__coverhead-title">
                <h3>Policy Schedule</h3>
              </div>
            </header>
            <div class="pdf__index">
              <ul class="list-unstyled pdf-index">
              </ul>
            </div>
          </div>
          <footer class="pdf-page__footer">
            <div class="pdf-page__footer-inner">
              <img [src]="footer?.footer_logo" alt="Everything.Insure">
              <p [innerHTML]="footer?.footer_copy"></p>
              <div>p. <span class="pdf-page-num"></span></div>
            </div>
          </footer>
        </section>
      }
      <!-- <section class="pdf-page">
      <div class="pdf-page__component">
        <div class="pdf__index">
          <h2 class="font-serif">Index</h2>
          <ul class="list-unstyled pdf-index">

          </ul>
        </div>
      </div>
      <footer class="pdf-page__footer">
        <div class="pdf-page__footer-inner">
          <img [src]="footer?.footer_logo" alt="Everything.Insure">
          <p [innerHTML]="footer?.footer_copy"></p>
          <div>p. <span class="pdf-page-num"></span></div>
        </div>
      </footer>
    </section> -->


    <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-details" data-title="Details">
      @if (pdfDoc) {
        <div  class="pdf-page__component">
          <div class="pdf__letterhead">
            <h2>Quote Schedule</h2>
            <div class="pdf__letterhead-details">
              <ul class="list-unstyled">
                <li>Date: <span class="font-semibold">{{quoteDetails?.['quote date'] | date: 'longDate'}}</span></li>
                <li>Quote No: <span class="font-semibold">{{quoteDetails?.['quote no']}}</span></li>
                <!-- <li>Version: <span class="font-semibold">{{quoteDetails?.version_id}}</span></li> -->
                <li>Quote Holder: <span class="font-semibold">{{policyHolderDetails?.policyholder}}</span></li>
                <li>Product: <span class="font-semibold">{{quoteDetails?.['product']}}</span></li>
              </ul>
            </div>
            <div class="pdf__letterhead-company">
              <img src="{{quoteDetails?.productLogo}}" class="img-fluid">
            </div>
          </div>
        </div>
      }


      <!-- TO FIX: showing 1 an extra empty component -->
      @for (item of quoteDataset; track item; let i = $index) {
        <ng-container>
          <div class="pdf-page__component">
            <!-- only show 'Details' title on first item -->
            @if (i === 0) {
              <div class="pdf-page__component-title">
                <div class="pdf-page__component-title-text">
                  <h2 class="font-serif">Details</h2>
                </div>
              </div>
            }
            <div class="pdf__data">
              <div class="pdf__data-title">
                <h4>
                  {{item?.header}}
                </h4>
              </div>
              @for (d of objectKeys(item); track d) {
                <span>
                  <div class="pdf__data-table">
                    <ul class="data">
                      @if (d !== 'header' && d !== 'index'
                        && d.toString() !== 'product_logo'
                        && d.toString() !== 'broker_logo_1'
                        && d.toString() !== 'broker_logo_2'
                        && d.toString() !== 'frequency_name'
                        && d.toString() !== 'frequency_short'
                        && d.toString() !== 'frequency_suffix'
                        ) {
                        <li class="data__row">
                          <label class="data__label">
                            {{(d.toString()) | titlecase}}
                          </label>
                          <div class="data__cell" active>
                            {{( item[ d.toString() ])}}
                            <!-- {{( item[ d.toString() ]) | titlecase}} -->
                          </div>
                          <ng-template #active>
                            <div class="data__cell">
                              Active
                            </div>
                          </ng-template>
                        </li>
                      }
                    </ul>
                  </div>
                </span>
              }
            </div>
          </div>
        </ng-container>
      }


      @if (false) {
        <div class="pdf-page__component">
          <div class="pdf__data">
            <div class="pdf__data-title">
              <h4>Class Insurers</h4>
            </div>
            <div class="pdf__data-table">
              <ul class="data">
                @for (item of classInsurers; track item) {
                  <li class="data__row">
                    <label class="data__label">
                      {{toTitleCase(item?.header)}}
                    </label>
                    <div class="data__cell">
                      {{item?.insurer_name}}
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      }

      @if (notes?.length) {
        <div class="pdf-page__component">
          <div class="pdf__note">
            <div class="pdf__note-icon">
              <svg class="icon">
                <use xlink:href="#info-small"></use>
              </svg>
            </div>
            <div class="pdf__note-content">
              <h5>{{notes[0]?.header}}</h5>
              @for (note of notes; track note) {
                <p [innerHTML]="note?.note"></p>
              }
            </div>
          </div>
        </div>
      }

      @if (pdfDoc) {
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img [src]="footer?.footer_logo" alt="Everything.Insure">
            <p [innerHTML]="footer?.footer_copy"></p>
            <div>p. <span class="pdf-page-num"></span></div>
          </div>
        </footer>
      }
    </section>


    <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-quote-summary" data-title="Quote Summary">
      <div class="pdf-page__component">

        <div class="pdf-page__component-title">
          <div class="pdf-page__component-title-text">
            <h2 class="font-serif">Quote Summary</h2>
            <p class="pdf-title-note"><small>Note that the full list of <strong>Conditions</strong> can be found
            at the end of the document on page <span class="pdf-page-x"
          data-target="conditions">X</span>.</small></p>
        </div>
      </div>

      <div class="table-pdf-wrap">
        <table class="table table--pdf table--pdf-summary">
          <thead>
            <tr>
              <th>Item Details</th>
              <th class="cell-100">Insurer</th>
              <th class="cell-100">Sum Insured</th>
              <th class="cell-105 cell-right">Basic Excess</th>
              <th class="cell-100 cell-right">Premium</th>
            </tr>
          </thead>
          <tbody>

            @for (item of getQuoteSummaryClasses(); track item; let i = $index) {
              <ng-container>
                <tr>
                  <th colspan="3" class="cell-pdf-sub font-uppercase">
                    <img src="{{item?.img_path}}" alt="" class="icon">
                    {{item?.header}}
                  </th>
                  <th colspan="2" class="cell-pdf-subtotal">
                    <strong>{{item?.premium}}</strong>/{{getFrequemcy()}}
                  </th>
                </tr>
              </ng-container>
              @for (itemDetail of getQuoteSummaryClassItems(item?.class_id); track itemDetail) {
                @if (item !== 'Benefits' && item !== 'Fees and Taxes') {
                  <tr>
                    <td class="cell-medium">{{itemDetail?.description_2}}</td>
                    <td class="cell-140">{{itemDetail?.insurer_name ? itemDetail?.insurer_name : '-'}}</td>
                    <!-- TO FIX: null values in data -->
                    <td class="cell-105 nowrap">{{itemDetail?.sum_insured}}</td>
                    <td class="cell-105 cell-right cell-medium">{{itemDetail?.excess}}</td>
                    <td class="cell-140 cell-right cell-medium">{{itemDetail?.premium}}/{{getFrequemcy()}}</td>
                  </tr>
                }
              }
            }

          </tbody>
        </table>
      </div>

    </div>

    @if (benefitTranscripts?.length > 0) {
      <div class="pdf-page__component">
        <div class="pdf__benefits">
          <div class="pdf__benefits-list">
            <h4>Key Benefits</h4>
            <ul class="list-unstyled">
              @for (item of getBenefitsForSummary(); track item; let i = $index) {
                <li><img src="{{item?.img_path}}" class="icon"> {{item?.vaps_name}}
                </li>
              }
            </ul>
          </div>
          <p>The full benefit list can be found on the <strong>Benefits Summary</strong> page.</p>
        </div>
      </div>
    }
    <div class="pdf-page__component">
      <div class="pdf__tabletotal">

        <div class="pdf__tabletotal-inner">
          <div class="pdf__tabletotal-subtotals">
            <div class="pdf__tabletotal-company">
              <img src="{{quoteDetails?.product_logo}}" class="img-fluid">
            </div>

            <div class="pdf__tabletotal-subtotal">
              <label>Items Subtotal</label>
              <p><strong>{{getQuoteSubTotal()}}</strong>/{{getFrequemcy()}}</p>
            </div>

            <div class="pdf__tabletotal-subtotal">
              <label>Benefits Subtotal</label>
              <p><strong>{{getBenefitsTotal()}}</strong>/{{getFrequemcy()}}</p>
            </div>

            <div class="pdf__tabletotal-subtotal">
              <label>Fees Subtotal</label>
              <p><strong>{{getFeesAndTaxes()}}</strong>/{{getFrequemcy()}}</p>
            </div>

            <div class="pdf__tabletotal-subtotal">
              <label>SASRIA Subtotal</label>
              <p><strong>{{getSasria()}}</strong>/{{getFrequemcy()}}</p>
            </div>

          </div>

          <div class="pdf__tabletotal-total">
            <div class="pdf__tabletotal-cost">
              <label>Policy Premium Total</label>
              <p><strong>{{getQuoteTotal()}}</strong>/{{getFrequemcy()}}
            </p>
          </div>
          <div class="pdf__tabletotal-text">
            <small>Total includes all taxes</small>
          </div>
        </div>
      </div>

      <ul class="pdf__tabletotal-extras list-unstyled">
        <li>Taxes {{getTaxes()}}</li>
        <!-- <ng-container *ngFor="let item of distinctList$ | async; let i = index">
        <ng-container *ngIf="item === 'Fees and Taxes'">


        </ng-container>
      </ng-container> -->
    </ul>

  </div>
</div>


@if (pdfDoc) {
  <footer class="pdf-page__footer">
    <div class="pdf-page__footer-inner">
      <img [src]="footer?.footer_logo" alt="Everything.Insure">
      <p [innerHTML]="footer?.footer_copy"></p>
      <div>p. <span class="pdf-page-num"></span></div>
    </div>
  </footer>
}
</section>

@if (benefitTranscripts?.length > 0) {
  <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-benefits-summary"
    data-title="Benefits Summary">
    <div class="pdf-page__component">
      <div class="pdf-page__component-title">
        <div class="pdf-page__component-title-text">
          <h2 class="font-serif">Benefits Summary</h2>
          <p class="pdf-title-note"><small>Note that the full list of <strong>Benefit Conditions</strong> can
          be found at the end of the document on page <span class="pdf-page-x"
        data-target="benefits-conditions">X</span>.</small></p>
      </div>
    </div>
    <div class="table-pdf-wrap">
      <table class="table table--pdf table--pdf-summary">
        <thead>
          <tr>
            <th class="cell-140">Benefit name</th>
            <th class="cell-140">Linked to</th>
            <th class="cell-80">Cover</th>
            <th class="cell-100">Insurer</th>
            <th class="cell-80 cell-right">Excess</th>
            <th class="cell-80">Type</th>
            <th class="cell-100 cell-right">Premium</th>
          </tr>
        </thead>
        <tbody>
          <!-- TO FIX: we should group all results of the same class_name together -->
          @for (itemDetail of getClasses(); track itemDetail; let vapIndex = $index) {
            @if (getBenefits(itemDetail?.class_id)?.length > 0) {
              <tr>
                <th colspan="7" class="cell-pdf-sub font-uppercase">
                  <img src="{{itemDetail?.img_path}}" alt="" class="icon"><!-- wrong icon -->
                  {{itemDetail?.class_name}}
                </th>
              </tr>
            }
            @for (vapsItem of getBenefits(itemDetail?.class_id); let vapItemIndex = $index; track vapsItem) {
              <tr>
                <th class="cell-benefit">
                  <div class="d-flex align-items-center">
                    <img src="{{vapsItem?.img_path}}" alt="" class="icon">
                    <span>{{vapsItem?.vaps_name}}</span>
                  </div>
                </th>
                <td class="cell-140 cell-medium">{{vapsItem.description_1}}</td>
                <td class="cell-80">{{vapsItem.sum_insured}}</td>
                <td class="cell-100 cell-medium">{{itemDetail?.insurer_name}}</td>
                <td class="cell-80 cell-right cell-medium">{{vapsItem.excess}}</td>
                <td class="cell-80 cell-medium">{{vapsItem.vaps_rel}}</td>
                <td class="cell-100 cell-right">
                  <p><strong class="font-16">{{vapsItem.premium}}</strong><wbr>/{{getFrequemcy()}}</p>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
  @if (pdfDoc) {
    <footer class="pdf-page__footer">
      <div class="pdf-page__footer-inner">
        <img [src]="footer?.footer_logo" alt="Everything.Insure">
        <p [innerHTML]="footer?.footer_copy"></p>
        <div>p. <span class="pdf-page-num"></span></div>
      </div>
    </footer>
  }
</section>
}


<!--
DATASET NINE / Class Items / Insured Items (excluding Personal Accident, Personal Liability, Personal Legal Costs)
TO FIX: showing components with no data
-->

@for (setNineHeaders of classHeaders; track setNineHeaders; let i = $index) {
  <!-- <ng-container *ngIf="setNineHeaders !== 'Personal Accident' && setNineHeaders !== 'Personal Liability' && setNineHeaders !== 'Personal Legal Costs'"> -->
  <ng-container>
    <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'"  [id]="constructID(setNineHeaders?.class_name)"
      [attr.data-title]="setNineHeaders?.class_name">
      <!-- ITEM DETAIL & ITEM TRANSCRIPTS -->
      @for (itemDetail of getDatasetNineClassItemDetail(setNineHeaders?.class_name); track itemDetail; let j = $index) {
        <div class="pdf-page__component">
          <!-- HEADER -->
          @if (j === 0) {
            <div class="pdf-page__component-title">
              <div class="pdf-page__component-title-text">
                <h2 class="font-serif">{{setNineHeaders?.class_name}}</h2>
                <p class="pdf-title-note"><small>Note that the full list of <strong>{{setNineHeaders?.class_name}}
                Conditions</strong>
                can be found at the end of the document
                <!--on page <span class="pdf-page-x"
              [attr.data-target]="setNineHeaders.replace(' ', '-').toLowerCase()+'-conditions'">X</span>-->.</small>
            </p>
          </div>
          <div class="pdf-page__component-logo">
            <p>with {{setNineHeaders?.insurer_name}}</p>
            <div>
              <img src="{{setNineHeaders?.insurer_img}}" class="img-fluid">
            </div>
          </div>
        </div>
      }
      <div class="table-pdf-wrap">
        <table class="table table--pdf">
          <thead>
            <tr>
              <th class="cell-condition-title">
                <div class="d-flex align-items-center">
                  <img src="{{getImageForClass(itemDetail?.class_name)}}" alt="" class="icon">
                  <span>{{itemDetail?.description_1}}</span>
                  <p>
                    <span>Premium:</span>
                    {{' '}}
                    <strong>{{itemDetail?.premium}}<wbr>/{{getFrequemcy()}}</strong>
                  </p>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="cell-nopad">
                <div class="pdf__data-table">
                  <ul class="data data--grid data--table data--compact">
                    <li class="data__row">
                      <label class="data__label">
                        Start Date
                        <strong>{{quoteDetails?.['quote date'] | date: 'longDate'}}</strong>
                      </label>
                      <div class="data__cell">
                        Sum Insured
                        <strong>{{itemDetail?.sum_insured}}</strong>
                      </div>
                    </li>
                    <li class="data__row">
                      <label class="data__label">
                        Basic Excess
                        <strong>{{itemDetail?.excess}}</strong>
                      </label>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <!-- Item Transcript -->
            @if (itemDetail?.premium !== 'R0' && getDatasetNineClassItemTranscript(setNineHeaders?.class_name, itemDetail?.item_id).length > 0) {
              <tr>
                <th class="cell-pdf-sub font-uppercase">
                  Item Transcript
                </th>
              </tr>
              <tr>
                <td class="cell-nopad">
                  <div class="pdf__data-table">
                    <ul class="data data--grid data--table">
                      @for (itemTranscript of getDatasetNineClassItemTranscript(setNineHeaders?.class_name, itemDetail?.item_id); track itemTranscript) {
                        <li class="data__row">
                          <label class="data__label">
                            {{itemTranscript?.question_prompt}}
                          </label>
                          <div class="data__cell">
                            {{itemTranscript?.response}}
                          </div>
                          <div class="data__cell">
                            <small><i>{{itemTranscript?.comment}}</i></small>
                          </div>
                        </li>
                      }
                    </ul>
                  </div>
                </td>
              </tr>
            }
            <tr>
              <td class="cell-condition-footer">
                @if (getDatasetTenBenefitsVapsDetail(itemDetail?.class_id)?.length) {
                  <div
                    class="pdf__benefits pdf__benefits--cell">
                    <div class="pdf__benefits-list">
                      <h4>LINKED BENEFITS</h4>
                      <ul class="list-unstyled">
                        @for (itemDetail of getDatasetTenBenefitsVapsDetail(itemDetail?.class_id); track itemDetail; let vapIndex = $index) {
                          <li
                            >
                            <img src="{{itemDetail?.img_path}}" class="icon">
                            {{itemDetail?.vaps_name}}
                          </li>
                        }
                      </ul>
                    </div>
                    <p>View the <strong>Benefits Summary</strong> section for more details.</p>
                  </div>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  }
  @if (pdfDoc) {
    <footer class="pdf-page__footer">
      <div class="pdf-page__footer-inner">
        <img [src]="footer?.footer_logo" alt="Everything.Insure">
        <p [innerHTML]="footer?.footer_copy"></p>
        <div>p. <span class="pdf-page-num"></span></div>
      </div>
    </footer>
  }
</section>
</ng-container>
}

<!-- Conditions: -->

<section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-conditions" data-title="Conditions">

  @if (policyWordings?.length > 0 ) {
    <div class="pdf-page__component">
      <div class="pdf-page__component-title">
        <div class="pdf-page__component-title-text">
          <h2 class="font-serif" id="conditions">Conditions</h2>
        </div>
      </div>
      <ng-container>
        <h3>Quote Conditions</h3>
        <!-- overall policy conditions -->
        <div class="table-pdf-wrap">
          <table class="table table--pdf table--pdf-conditions">
            <tbody>
              <tr>
                <th class="font-uppercase">
                  Title
                </th>
                <th class="font-uppercase">
                  Description
                </th>
                <th class="cell-100 cell-right font-uppercase">
                  Amount
                </th>
                <th class="cell-100 cell-right font-uppercase">
                  Excess
                </th>
              </tr>
              <!-- condition to repeat -->
              @for (wording of policyWordings; track wording) {
                @if (wording?.['wording header']) {
                  <tr>
                    <td>
                      <strong [innerHTML]="wording?.['wording header']"></strong>
                    </td>
                    <td class="cell-condition cell-360" [innerHTML]="wording?.['wording body']">
                    </td>
                    <td class="cell-100 cell-right cell-medium">
                      {{wording?.['wording amount']}}
                    </td>
                    <td class="cell-100 cell-right cell-medium">
                      {{wording?.['wording excess']}}
                    </td>
                  </tr>
                }
              }
              <!-- /condition to repeat -->
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  }

  <!-- class to repeat -->

  @for (setNineHeaders of classHeaders; track setNineHeaders; let i = $index) {
    <!-- insured item class conditions -->
    @for (itemDetail of getDatasetNineClassItemDetail(setNineHeaders?.class_name); track itemDetail; let j = $index) {
      @if (getDatasetNineClassItemWording(setNineHeaders?.class_name,itemDetail?.item_id).length > 0) {
        <div
          class="pdf-page__component" [class]="j === 0 ? 'is-sub' : null"
          [attr.data-component-title]="j > 0 ? setNineHeaders?.class_name : null">
          <h3 id="{{setNineHeaders?.class_name.replace(' ', '-').toLowerCase()}}-conditions">{{setNineHeaders?.class_name}}
          Conditions</h3>
          <div class="table-pdf-wrap">
            <table class="table table--pdf table--pdf-conditions">
              <thead>
                <tr>
                  <th class="cell-condition-title" colspan="4">
                    <div class="d-flex align-items-center">
                      <!-- TO FIX: should be showing class icon -->
                      <img src="{{getImageForClass(itemDetail?.class_name)}}" alt="" class="icon">
                      <span> {{itemDetail.description_1}}</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="font-uppercase">
                    Title
                  </th>
                  <th class="font-uppercase">
                    Description
                  </th>
                  <th class="cell-100 cell-right font-uppercase">
                    Amount
                  </th>
                  <th class="cell-100 cell-right font-uppercase">
                    Excess
                  </th>
                </tr>
                <!-- condition to repeat -->
                @for (itemWording of getDatasetNineClassItemWording(setNineHeaders?.class_name, itemDetail?.item_id); track itemWording) {
                  @if (itemWording?.wording_header) {
                    <tr>
                      <td>
                        <strong [innerHTML]="itemWording?.wording_header"></strong><br>
                      </td>
                      <td class="cell-condition cell-360" [innerHTML]="itemWording?.wording_body">
                      </td>
                      <td class="cell-100 cell-right cell-medium">
                        {{itemWording?.wording_amount}}
                      </td>
                      <td class="cell-100 cell-right cell-medium">
                        {{itemWording?.wording_excess}}
                      </td>
                    </tr>
                  }
                }
                <!-- /condition to repeat -->
              </tbody>
            </table>
          </div>
        </div>
      }
    }
    <!-- general class conditions -->
    @if (getClassWording(setNineHeaders?.class_id).length > 0) {
      @if (setNineHeaders?.class_name !== 'Personal Accident' && setNineHeaders?.class_name !== 'Personal Liability' && setNineHeaders?.class_name  !== 'Personal Legal Costs') {
        <div
          class="pdf-page__component is-sub">
          <h3 id="general-{{setNineHeaders?.class_name.replace(' ', '-').toLowerCase()}}-conditions">General
            {{setNineHeaders?.class_name }}
          Conditions</h3>
          <!-- TO DO: show note if exists -->
          <!-- <div class="pdf__note">
          <div class="pdf__note-icon">
            <svg class="icon">
              <use xlink:href="#info-small"></use>
            </svg>
          </div>
          <div class="pdf__note-content">
            <p>[Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius, at.]
            </p>
          </div>
        </div> -->
        <div class="table-pdf-wrap">
          <table class="table table--pdf table--pdf-conditions">
            <tbody>
              <tr>
                <th class="font-uppercase">
                  Title
                </th>
                <th class="font-uppercase">
                  Description
                </th>
                <th class="cell-100 cell-right font-uppercase">
                  Amount
                </th>
                <th class="cell-100 cell-right font-uppercase">
                  Excess
                </th>
              </tr>
              @for (wording of getDatasetNineClassWording(setNineHeaders?.class_name ); track wording) {
                <!-- condition to repeat -->
                @if (wording?.wording_header) {
                  <tr>
                    <td>
                      <strong [innerHTML]="wording?.wording_header"></strong><br>
                    </td>
                    <td class="cell-condition cell-360" [innerHTML]="wording?.wording_body">
                    </td>
                    <td class="cell-100 cell-right cell-medium">
                      {{wording?.wording_amount}}
                    </td>
                    <td class="cell-100 cell-right cell-medium">
                      {{wording?.wording_excess}}
                    </td>
                  </tr>
                }
              }
              <!-- /condition to repeat -->
            </tbody>
          </table>
        </div>
      </div>
    }
    @if (setNineHeaders === 'Personal Accident' || setNineHeaders === 'Personal Liability' || setNineHeaders === 'Personal Legal Costs') {
      <div
        class="pdf-page__component is-sub">
        <h3 id="{{setNineHeaders.replace(' ', '-').toLowerCase()}}-conditions">{{setNineHeaders}} Conditions
        </h3>
        <div class="table-pdf-wrap">
          <table class="table table--pdf table--pdf-conditions">
            <thead>
              <tr>
                <th class="cell-condition-title" colspan="4">
                  <div class="d-flex align-items-center">
                    <img src="https://assets.everything.insure/icn/30px-personal-accident.svg" alt=""
                      class="icon">
                      <span>{{setNineHeaders}}</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="font-uppercase">
                    Title
                  </th>
                  <th class="font-uppercase">
                    Description
                  </th>
                  <th class="cell-100 cell-right font-uppercase">
                    Amount
                  </th>
                  <th class="cell-100 cell-right font-uppercase">
                    Excess
                  </th>
                </tr>
                <!-- condition to repeat -->
                @for (wording of getDatasetNineClassWording(setNineHeaders); track wording) {
                  @if (wording?.wording_header) {
                    <tr>
                      <td>
                        <strong [innerHTML]="wording?.wording_header"></strong><br>
                      </td>
                      <td class="cell-condition cell-360" [innerHTML]="wording.wording_body">
                      </td>
                      <td class="cell-100 cell-right cell-medium">
                        {{wording?.wording_amount}}
                      </td>
                      <td class="cell-100 cell-right cell-medium">
                        {{wording?.wording_excess}}
                      </td>
                    </tr>
                  }
                }
                <!-- /condition to repeat -->
              </tbody>
            </table>
          </div>
        </div>
      }
    }
  }
  <!-- /to repeat -->

  @if (pdfDoc) {
    <footer class="pdf-page__footer">
      <div class="pdf-page__footer-inner">
        <img [src]="footer?.footer_logo" alt="Everything.Insure">
        <p [innerHTML]="footer?.footer_copy"></p>
        <div>p. <span class="pdf-page-num"></span></div>
      </div>
    </footer>
  }
</section>


<!-- Benefits conditions: -->

@if (checkIfVapsWordingExists()?.length > 0) {
  <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" id="anchor-benefits-conditions" data-title="Benefits Conditions"
    >
    <div class="pdf-page__component-title">
      <div class="pdf-page__component-title-text">
        <h2 class="font-serif" id="benefits-conditions">Benefits Conditions</h2>
      </div>
    </div>
    @for (itemDetail of getVapClasses(); track itemDetail; let vapIndex = $index) {
      @if (getDatasetTenBenefitsVapsWordingByClass(itemDetail?.class_id).length > 0) {
        @for (item of getDatasetTenBenefitsVapsWordingByClass(itemDetail?.class_id) ; track item; let idx = $index) {
          <div class="pdf-page__component"
            [class]="(vapIndex > 0 && vapItemIndex === 0) ? 'is-sub' : null"
            [attr.data-component-title]="vapItemIndex > 0 ? itemDetail?.class_name + ' Benefits Conditions' : null">
            @if (idx === 0) {
              <h3>{{itemDetail?.class_name}} Benefits Conditions</h3>
            }
            <div class="table-pdf-wrap">
              <table class="table table--pdf table--pdf-conditions table--pdf-legal">
                <thead>
                  <tr>
                    <th class="cell-condition-title" colspan="4">
                      <div class="d-flex align-items-center">
                        <img src="https://assets.everything.insure/icn/vaps/sm-{{item?.vaps_id}}.svg" alt=""
                          class="icon">
                          <span>{{item?.vaps_name}}</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th class="font-uppercase">
                        Title
                      </th>
                      <th class="font-uppercase">
                        Description
                      </th>
                      <th class="cell-100 cell-right font-uppercase">
                        Amount
                      </th>
                      <th class="cell-100 cell-right font-uppercase">
                        Excess
                      </th>
                    </tr>
                    @for (wording of getDatasetTenBenefitsVapsWording(item?.vaps_id); track wording) {
                      <tr>
                        <td>
                          <strong [innerHTML]="wording?.wording_header"></strong><br>
                        </td>
                        <td class="cell-legal" [innerHTML]="wording?.wording_body">
                        </td>
                        <td class="cell-100 cell-right cell-medium cell-legal-num">
                          {{wording?.wording_amount}}
                        </td>
                        <td class="cell-100 cell-right cell-medium cell-legal-num">
                          {{wording?.wording_excess}}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
        }
      }
      <!--Sam-->
      <!-- <ng-container *ngFor="let itemDetail of getDatasetTenBenefitsVapsDetail(); let vapIndex = index"> -->
      @if (false) {
        <!-- TO FIX: group by classes -->
        @for (vapsItem of getDatasetTenBenefitsVapsItems(itemDetail?.vaps_id); track vapsItem; let vapItemIndex = $index) {
          <!-- TO FIX: list benefits per class -->
          @if (getDatasetTenBenefitsVapsWording(itemDetail?.vaps_id).length > 0) {
            <div class="pdf-page__component"
              [class]="(vapIndex > 0 && vapItemIndex === 0) ? 'is-sub' : null"
              [attr.data-component-title]="vapItemIndex > 0 ? itemDetail?.class_name + ' Benefits Conditions' : null">
              <!-- <div class="pdf-page__component-title" *ngIf="vapIndex === 0">
              <div class="pdf-page__component-title-text">
                <h2 class="font-serif" id="benefits-conditions">Benefits Conditions</h2>
              </div>
            </div> -->
            @if (vapItemIndex === 0) {
              <h3>{{itemDetail?.class_name}} Benefits Conditions</h3>
            }
            <div class="table-pdf-wrap">
              <table class="table table--pdf table--pdf-conditions table--pdf-legal">
                <thead>
                  <tr>
                    <th class="cell-condition-title" colspan="4">
                      <div class="d-flex align-items-center">
                        <img src="https://assets.everything.insure/icn/vehicle-outline.svg" alt="" class="icon">
                        <span>{{itemDetail?.vaps_name}}</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th class="font-uppercase">
                      Title
                    </th>
                    <th class="font-uppercase">
                      Description
                    </th>
                    <th class="cell-100 cell-right font-uppercase">
                      Amount
                    </th>
                    <th class="cell-100 cell-right font-uppercase">
                      Excess
                    </th>
                  </tr>
                  @for (wording of getDatasetTenBenefitsVapsWording(itemDetail?.vaps_id); track wording) {
                    @if (wording?.wording_header) {
                      <tr>
                        <td>
                          <strong [innerHTML]="wording?.wording_type"></strong><br>
                        </td>
                        <td class="cell-legal" [innerHTML]="wording?.wording_html">
                        </td>
                        <td class="cell-100 cell-right cell-medium cell-legal-num">
                          {{wording?.wording_amount}}
                        </td>
                        <td class="cell-100 cell-right cell-medium cell-legal-num">
                          {{wording?.excess}}
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      }
    }
    @if (pdfDoc) {
      <footer class="pdf-page__footer">
        <div class="pdf-page__footer-inner">
          <img [src]="footer?.footer_logo" alt="Everything.Insure">
          <p [innerHTML]="footer?.footer_copy"></p>
          <div>p. <span class="pdf-page-num"></span></div>
        </div>
      </footer>
    }
  </section>
}


<!-- Disclosure notice: -->
@if (getDisclosureNotice()?.length > 0) {
  <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'"  id="anchor-disclosure-notice"
    data-title="Disclosure Notice">
    @for (alwaysTopNotice of getDisclosureNotice(disclosureNoticeHeaderType.ALWAYS_ON_TOP); track alwaysTopNotice) {
      <div [innerHtml]="alwaysTopNotice?.description_print"></div>
    }
    <app-disclosure-notice [disclosure]="getDisclosureNotice()">
    </app-disclosure-notice>
    <div class="pdf-page__component">
      <div class="table-pdf-wrap">
        @for (alwaysTopNotice of getDisclosureNotice(disclosureNoticeHeaderType.ALWAYS_ON_BOTTOM); track alwaysTopNotice) {
          <ng-container #lastDisclosureNotice
            >
            <div [innerHtml]="alwaysTopNotice?.description_print"></div>
          </ng-container>
        }
      </div>
    </div>
    @if (pdfDoc) {
      <footer class="pdf-page__footer">
        <div class="pdf-page__footer-inner">
          <img [src]="footer?.footer_logo" alt="Everything.Insure">
          <p [innerHTML]="footer?.footer_copy"></p>
          <div>p. <span class="pdf-page-num"></span></div>
        </div>
      </footer>
    }
  </section>
}
</div>
</div>
</div>
</main>
<div class="sidesheet sidesheet--menu" id="sidesheet">
  <div class="sidesheet__inner">

    <div class="sidesheet__body">

      <div class="has-scrollto">
        <ul class="central-nav__list list-unstyled" id="docs-nav-mobile">
          <li>
            <a href="#anchor-overview"><span>Overview</span></a>
          </li>
          <li>
            <a href="#anchor-details"><span>Details</span></a>
          </li>
          <li>
            <a href="#anchor-policy-summary"><span>Policy Summary</span></a>
          </li>
          <li>
            <a href="#anchor-benefits-summary"><span>Benefits Summary</span></a>
          </li>
          @for (setNineHeaders of classHeaders; track setNineHeaders; let i = $index) {
            <li>
              <a [href]="'#'+constructID(setNineHeaders?.class_name)"><span>{{setNineHeaders?.class_name}}</span></a>
            </li>
          }
          <li>
            <a href="#anchor-conditions"><span>Conditions</span></a>
          </li>
          <li>
            <a href="#anchor-benefits-conditions"><span>Benefits Conditions</span></a>
          </li>
          <li>
            <a href="#anchor-disclosure-notice"><span>Disclosure Notice</span></a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>
<div class="sidesheet__overlay"></div>
<div class="modal fade modal--tray" id="modal-share-menu" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-more" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">

          <a href="javascript:;" (click)="preparePDF()" data-dismiss="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#download"></use>
            </svg>
            <div>Download</div>
          </a>
        </div>

        <a href="#" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>
<!-- pdf preview modal -->
<div class="modal fade modal--fullscreen" id="modal-pdf-preview" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-policy-feed__heading">
        <div class="container">
          <h6>PDF Preview</h6>
          <a href="javascript:;" class="modal-policy-feed__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </div>
      <div class="modal-body p-0" style="height: calc(100% - 56px);">
        @if (previewFileUrl) {
          <iframe [src]="previewFileUrl" width="100%" height="100%" frameborder="0" (load)="onPdfIframeLoad()"></iframe>
        }
      </div>
    </div>
  </div>
</div>
<!-- pdf preview modal -->
<div class="modal fade modal--fullscreen" id="modal-pdf-preview" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-policy-feed__heading">
        <div class="container">
          <h6>PDF Preview</h6>
          <a href="javascript:;" class="modal-policy-feed__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </div>
      <div class="modal-body p-0" style="height: calc(100% - 56px);">
        <iframe *ngIf="previewFileUrl" [src]="previewFileUrl" width="100%" height="100%" frameborder="0" (load)="onPdfIframeLoad()"></iframe>
      </div>
    </div>
  </div>
</div>